// PostHog product analytics chokepoint. ALL event capture flows through
// track() — posthog-js must never be imported anywhere else (enforced by
// backend/tests/test_analytics_compliance_guard.py).
import posthog from "posthog-js";

// Compliance (non-negotiable): event properties may contain ONLY these string
// keys plus numeric counts. Candidate PII, transcript text, interview titles,
// candidate names, CV content or any interview-derived content never pass.
const ALLOWED_STRING_KEYS = ["workspace_id", "plan", "role"];

const EVENTS = [
  "signup_completed",
  "workspace_created",
  "interview_recorded",
  "transcription_completed",
  "scorecard_submitted",
  "paywall_hit",
];

// Production-only initialization: never from preview/dev hosts.
const DENYLISTED_HOSTS = /(^localhost$)|(^127\.)|(\.preview\.emergentagent\.com$)/;

let initialized = false;

function analyticsAllowed() {
  if (!process.env.REACT_APP_POSTHOG_KEY) return false;
  if (process.env.NODE_ENV !== "production") return false;
  return !DENYLISTED_HOSTS.test(window.location.hostname);
}

export function initAnalytics() {
  if (initialized || !analyticsAllowed()) return;
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_POSTHOG_HOST,
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    disable_session_recording: true,
  });
  initialized = true;
}

// Hard scrub: allowlisted string keys + finite numbers only. Everything else
// is silently dropped.
export function scrubProperties(props = {}) {
  const clean = {};
  for (const [key, value] of Object.entries(props)) {
    if (ALLOWED_STRING_KEYS.includes(key) && typeof value === "string") {
      clean[key] = value;
    } else if (typeof value === "number" && Number.isFinite(value)) {
      clean[key] = value;
    }
  }
  return clean;
}

export function track(event, properties = {}) {
  if (!EVENTS.includes(event)) return;
  const clean = scrubProperties(properties);
  if (!initialized) {
    if (process.env.NODE_ENV !== "production") {
      console.debug(`[analytics] ${event} (not sent — preview/dev)`, clean);
    }
    return;
  }
  posthog.capture(event, clean);
}
